import { createStore } from 'redux';
import rootReducer from './Reducers/indexReducer'

export default createStore(rootReducer)